/*
 * "Static column aside" product gallery: the stacked desktop layout wraps
 * into a 2-up grid at tablet widths, with no way to browse one photo at a
 * time. This shows one photo plus prev/next + dots instead — only visible
 * in that width band (see the tablet-gallery-nav/dots rules in
 * section-main-product.css); wide desktop and phones are a different
 * gallery type and untouched.
 */
(function () {
	'use strict';

	function setup(outer) {
		var list = outer.querySelector('.product__media-list');
		var nav = outer.querySelector('.tablet-gallery-nav');
		var dotsWrap = outer.querySelector('.tablet-gallery-dots');
		if (!list || !nav || !dotsWrap) return;

		var items = Array.prototype.slice.call(list.querySelectorAll('.product__media-item'));
		var dots = Array.prototype.slice.call(dotsWrap.querySelectorAll('.tablet-gallery-dots__dot'));
		if (items.length < 2) return;

		var index = 0;

		function render() {
			items.forEach(function (item, i) {
				item.classList.toggle('is-tablet-active', i === index);
			});
			dots.forEach(function (dot, i) {
				dot.classList.toggle('is-active', i === index);
			});
		}

		function go(delta) {
			index = (index + delta + items.length) % items.length;
			render();
		}

		nav.querySelector('.tablet-gallery-nav__prev').addEventListener('click', function () {
			go(-1);
		});
		nav.querySelector('.tablet-gallery-nav__next').addEventListener('click', function () {
			go(1);
		});

		render();
	}

	function init() {
		document
			.querySelectorAll('.product__outer--static-column-aside')
			.forEach(setup);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

	document.addEventListener('shopify:section:load', init);
})();
